import {
  PageContentContainer,
  PageLoading,
} from "@fp/ui/components/base/page-layout/page-layout";
import { AdminLayout } from "@/components/admin-layout";
import { AdminPageHeader } from "@/components/admin-page-header";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

export const Route = createFileRoute("/callback/plaid")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (hasRedirected.current) {
      return;
    }
    hasRedirected.current = true;

    navigate({ to: "/funding/link-account", search: { plaidOAuthRedirect: window.location.href } });
  }, [navigate]);

  return (
    <AdminLayout>
      <AdminPageHeader
        title="Link Bank Account"
        parent={{ url: "/funding", label: "Funding" }}
      />
      <PageContentContainer>
        <div className="flex flex-col items-center justify-center min-h-[400px]">
          <PageLoading />
          <p className="mt-4 text-gray-600">Completing your bank connection...</p>
        </div>
      </PageContentContainer>
    </AdminLayout>
  );
}